<script>
  import Header from "../header.svelte";
  import { onMount } from 'svelte';
  import { querystring } from 'svelte-spa-router';
  import Template from "./template.svelte";
  import { api_host, subdomain_manager, bpm_domain, user_store, ppm_host } from "../../stores.js";
  import { getToken, doFetch } from "../../utils/Fetching.js";
  import { toast_message } from '../../utils/toast_message.js';
  import Swal from "sweetalert2";
  import { handle_not_subscribed } from "../../utils/format.js";
  import { trial_domain_suffix } from '../../globals';


  let preview_url = '';
  let iframe_version = Date.now();
  let plan_type = '';
  let subdomain = '';
  subdomain_manager.subscribe(value => {
    console.log(value);
    subdomain = value;
    preview_url = `${bpm_domain.includes('localhost') ? 'http' : 'https'}://${subdomain}.${bpm_domain}`;
  });
  let editor;
  let first_loading = true;
  let is_free_version = false;
  let myself = {};
  let interval = '';
  let interval_number = -1;

  $: {
    if (plan_type) {
      user_store.update(prev => {
        prev['plan_type'] = plan_type;
        return prev;
      });
    }
  }

  user_store.subscribe(value => {
    myself = value;
    const params = new URLSearchParams($querystring);
    if (params.has('domain_name') && !myself.is_authenticated) {
      if (params.has('plan_type')) {
        plan_type = params.get('plan_type');
      } else {
        plan_type = 'free';
      }
      subdomain = params.get('domain_name');
      localStorage.setItem('HoyFreePlanType', plan_type);
      preview_url = `${bpm_domain.includes('localhost') ? 'http' : 'https'}://${subdomain}.${bpm_domain}`;
      is_free_version = true;
    }
    if (params.has('is_new_user')) {
      toast_message(true, "Edit your website", 3000);
    }
  });

  const toHHMMSS = (secs) => {
    var sec_num = parseInt(secs, 10)
    var hours   = Math.floor(sec_num / 3600)
    var minutes = Math.floor(sec_num / 60) % 60
    var seconds = sec_num % 60

    return [hours,minutes,seconds]
      .map(v => v < 10 ? "0" + v : v)
      .filter((v,i) => v !== "00" || i > 0)
      .join(":")
  }

  const { auth_type, auth_token, domain_code } = getToken();

  const get_content = async () => {
    let res = {};
    if (!is_free_version) {
      res = await doFetch(
        api_host + '/api/ex/get/content',
        'GET',
        {},
        { Authorization: `${auth_type} ${auth_token}`, 'Content-Type': 'application/json', 'DomainCode': domain_code }
      );
    } else {
      res = await doFetch(
        api_host + '/api/ex/get/content/public',
        'POST',
        { subdomain_name: subdomain },
        { Authorization: `${auth_type} ${auth_token}`, 'Content-Type': 'application/json', 'DomainCode': domain_code }
      );
    }
    if (res.status) {
      default_template = `<div><style>${editor.editor.getCss()}</style>${editor.editor.getHtml()}</div>`;
      let content = res.content;
      original_template = content;
      modified_template = content;
      editor.setComponents(content);
      if (is_free_version) {
        toast_message(true, 'Try website builder', 3000);
      }
      // if (res.created_at && res.created_at > 0) {
      //   const date = new Date();
      //   const now = date.getTime();
      //   const now_epoch = Math.floor(now / 1000);
      //   console.log(now_epoch, res.created_at, now_epoch - res.created_at);
      //   if (now_epoch - res.created_at < 3600) {
      //     interval_number = 3600 - (now_epoch - res.created_at);
      //     setInterval(() => {
      //       interval = ` (${toHHMMSS(interval_number)})`;
      //       interval_number -= 1;
      //     }, 1000);
      //   }
      // }
    } else {
      if (res.msg === 'Domain expired') {
        // toast_message(false, res.msg, 3000);
        if (!myself.is_authenticated) {
          console.log('Domain expired!!!');
          setTimeout(() => {
            window.location.href = `${ppm_host}/pricing`;
          }, 2000);
        } else {
          user_store.update(prev => {
            prev['is_domain_expired'] = true;
            return prev;
          });
        }
        return;
      }
      if (auth_type && auth_token && domain_code) {
        toast_message(false, "You don't have website, Publish your website", 3000);
      } else {
        toast_message(true, 'Try website builder', 3000);
      }
    }
  }

  onMount(async () => {
    setTimeout(function() {
      // localStorage.clear()
    }, 0);
    CKEDITOR.dtd.$editable.a = 1;
    var lp = './img/';
    var plp = '//placehold.it/350x250/';
    var images = [];
    // Set up GrapesJS editor with the MJML plugin
    editor = grapesjs.init({
      // selectorManager: { componentFirst: true },
      clearOnRender: true,
      height: '100%',
      avoidInlineStyle: false,
      noticeOnUnload: 0,
      storageManager: {
        type: null
      },
      // storageManager: {id: 'gjs-mjml-'},
      //storageManager:{ autoload: 0 },
      assetManager: {
        assets: images,
        upload: 0,
        uploadText: 'Uploading is not available in this demo',
      },
      container: '#gjs',
      fromElement: true,
      blockManager: {
        custom: true,
      },
      plugins: [
        // 'grapesjs-mjml',
        'gjs-plugin-ckeditor',
        'grapesjs-blocks-bootstrap4'
      ],
      pluginsOpts: {
        'gjs-plugin-ckeditor': {
          position: 'center',
          options: {
            startupFocus: true,
            extraAllowedContent: '*(*);*{*}', // Allows any class and any inline style
            allowedContent: true, // Disable auto-formatting, class removing, etc.
            enterMode: CKEDITOR.ENTER_BR,
            extraPlugins: 'sharedspace,justify,colorbutton,panelbutton,font',
            toolbar: [{
                name: 'styles',
                items: ['Font', 'FontSize']
              },
              ['Bold', 'Italic', 'Underline', 'Strike'],
              {
                name: 'paragraph',
                items: ['NumberedList', 'BulletedList']
              },
              {
                name: 'links',
                items: ['Link', 'Unlink']
              },
              {
                name: 'colors',
                items: ['TextColor', 'BGColor']
              },
            ],
          }
        }
      },
      canvas: {
        styles: [
          'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css',
          'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'
        ],
        scripts: [
          'https://code.jquery.com/jquery-3.3.1.slim.min.js',
          'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js',
          'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js'
        ],
      }
    });
    editor.BlockManager.add('a_block', {
      label: '<i class="fas fa-search" style="font-size: 32px;padding-bottom: 7px;"></i><br />Address Search',
      editable: false,
      draggable: true,
      stylable: true,
      selectable: true,
      category: 'Mandatory Elements',
      content: '<center class="search_box_cover"><input id="search_address" type="text" name="search" placeholder="Search address for instant quote." class="c1719"><span class="c1734"><svg class="bi bi-search" id="search_address_btn" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.442 10.442a1 1 0 011.415 0l3.85 3.85a1 1 0 01-1.414 1.415l-3.85-3.85a1 1 0 010-1.415z" clip-rule="evenodd"/><path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM13 6.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z" clip-rule="evenodd"/></svg></span></center>',
      attributes: {
        title: 'A block'
      },
    });
    editor.BlockManager.add('icon', {
      label: '<span style="font-size: 40px;">i</span><br />Custom Icon',
      editable: false,
      draggable: true,
      stylable: true,
      selectable: true,
      category: 'Custom Elements',
      // https://www.w3schools.com/icons/fontawesome_icons_intro.asp
      content: '<i class="fa fa-car"></i>',
      attributes: {
        title: 'Icon'
      },    
    });
    var titles = document.querySelectorAll('*[title]');
    for (var i = 0; i < titles.length; i++) {
      var el = titles[i];
      var title = el.getAttribute('title');
      title = title ? title.trim() : '';
      if (!title)
        break;
      el.setAttribute('data-tooltip', title);
      el.setAttribute('title', '');
    }
    editor.on('load', function() {
      const blockBtn = editor.Panels.getButton('views', 'open-blocks');
      blockBtn.set('active', 1);
    });
    var panelManager = editor.Panels;
    var styleManagerButton = panelManager.getButton("views", "open-sm");
    var blocksButton = panelManager.getButton("views", "open-blocks");
    panelManager.removeButton("views", "open-sm");
    panelManager.removeButton("views", "open-layers");
    panelManager.removeButton("views", "open-blocks");
    panelManager.addButton("views", blocksButton);
    panelManager.addButton("views", styleManagerButton);

    await get_content();
  });

  let is_busy = false;
  let default_template = '';
  let original_template = '';
  let modified_template = '';
  $: content_title = "Contents - Home Page";
  let disabled = true;

  async function togglePublish() {
    if (is_free_version || !myself.is_subscribed) {
      handle_not_subscribed();
      return;
    }
    is_busy = true;
    modified_template = `<div><style>${editor.editor.getCss()}</style>${editor.editor.getHtml()}</div>`;
    disabled = true;
    if (subdomain && subdomain !== 'sample') {
      const temp_preview_url = preview_url;
      preview_url = '';
      const res = await doFetch(api_host + '/api/ex/save/content', 'POST', {'html': modified_template, subdomain}, {'Content-Type': 'application/json', 'DomainCode': domain_code});
      if (res.status) toast_message(true, res.msg, 2000);
      else toast_message(false, res.msg, 2000);
      preview_url = temp_preview_url;
      iframe_version = Date.now();
    } else {
      toast_message(false, 'Homepage is not published. Register your domain first', 3000);
    }
    is_busy = false;
  }

  async function toggleReset() {
    if (is_free_version || !myself.is_subscribed) {
      handle_not_subscribed();
      return;
    }
    Swal.fire({
      title: 'Reset website to standard template?',
      text: '',
      buttonsStyling: true,
      cancelButtonText: "Cancel",
      showCancelButton: true,
      showConfirmButton: true,
      icon: "success"
    }).then(e => {
      if (e.isConfirmed) {
        editor.setComponents(default_template);
      }
    });
  }
</script>
  
<Header bind:title={content_title} bind:is_busy={is_busy} />

<div id="mobile-alert">
  Home Page editing is supported on laptop and desktop devices only.
  <!-- {#if is_free_version || (myself.is_authenticated && !myself.is_subscribed)}
    <span style='margin-top: 5px;'><b>{`Your domain expires in 1 hour${interval}. Choose a plan to secure your domain and unlock all features`}</b></span>
  {/if} -->
</div>

<div class="desktop toolsholder">
  <div style='display: flex;flex-direction: row;justify-content: space-between;'>
    <h6 style="margin-top: 8px;">My Domain: <a href={`${bpm_domain.includes('localhost') ? 'http' : 'https'}://${subdomain}.${bpm_domain}`} target="_blank">{subdomain}.{bpm_domain}</a></h6>
    {#if is_free_version || (myself.is_authenticated && !myself.is_subscribed)}
      <span style='margin-top: 5px;'>
        {#if myself.is_domain_expired}
          <!-- <b>Your domain expired. Choose a plan to secure your domain and unlock all features</b> -->
        <!-- {:else}
          <b>{`Your domain expires in 1 hour${interval}. Choose a plan to secure your domain and unlock all features`}</b> -->
        {/if}
      </span>
    {/if}
  </div>

  {#if !(myself.is_authenticated && myself.is_domain_expired)}
    <div class="buttonholder" style="margin-bottom: 15px;">
      {#if !disabled}
        <button on:click={()=>{togglePublish();}} disabled={is_busy}>Publish</button>
        <button on:click={()=>{toggleReset();}} disabled={is_busy}>Reset</button>
      {/if}
      <button on:click={()=>{
        if (disabled) {
          disabled = false;
        } else {
          disabled = true;
          modified_template = original_template;
          editor.setComponents(modified_template);
        }
      }} disabled={is_busy}>
        {disabled ? 'Edit My Home Page' : 'Cancel'}
      </button>
    </div>
  {/if}
</div>


<div class:fade-out={disabled} id="gjs" style="height:0px; overflow:hidden">
  <Template />
</div>

<div class:fade-out={!disabled} class="previewholder">
  {#if modified_template && preview_url}
    <iframe src={`${preview_url}?version=${iframe_version}`} style="border: 0px;" />
  {:else}
    <Template />
  {/if}
</div>


<style>
#gjs {
  transition: 0.5s ease all;
}
.fade-out {
  opacity: 0;
  display: none;
}
.buttonholder {
  margin-top: 10px;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}
.buttonholder button {
  max-width: 300px;
  /* width: 100%; */
  background-color: #357a38;
  color: white;
}
  :global(tr.css-monospace) {
  font-family: monospace !important;
}
#mobile-alert {
  display: none;
  white-space: pre-line;
}
.gjs-clm-tags {
  display: none;
}
.gjs-pn-btn {
  font-size: 18px!important;
}
.gjs-four-color {
  color: #f45e43;
}
.gjs-logo-version {
  background-color: #4b4e54;
}
.previewholder {
  width: 100%;
  height: 100%;
}
.previewholder iframe {
  width: 100%;
  height: 100%;
}
@media (max-device-width: 1024px),
(max-width: 1023px) {
  #gjs,
  .desktop {
    display: none;
  }
  #mobile-alert {
    display: block;
  }
}
#search_address_btn {
  top: 11px;
}
</style>
